import { useRouter } from 'next/router'
import { useEffect } from 'react'

import { useLogoutMutation } from 'api/usersApi'
import { mParticleLogoutUser } from 'mParticle/mParticleService'
import { setClientAnonymousUserId } from 'shared/utils/clientAnalyticsIds'

export const useAuth = () => {
  const { asPath, reload } = useRouter()
  const [logout, { isSuccess }] = useLogoutMutation()

  const logoutUser = async () => {
    await logout()
    setClientAnonymousUserId({ overwrite: true }) // Reset anonymous user ID
    mParticleLogoutUser()
  }

  useEffect(() => {
    if (isSuccess) {
      if (asPath.startsWith('/my-account')) {
        reload()
      }
    }
  }, [isSuccess])

  return {
    logoutUser,
  }
}
